import React, { useEffect, useState } from "react";
import InputField from "../../common/InputField";
import { get } from "../../utils/api";
import apiServer from "../../constants/apiServer";
import "../../css/artist.sass";


const GeneralInformation = ({ states, onChange, errorStates, onChangeSelect }) => {

  const [categoryList, setCategoryList] = useState([]);

  const {
    productEngName,
    productMyanName,
    productCode,
    chosenCategory,
    currency,
    price,
    quantity,
    engDescription,
    myanDescription
  } = states;

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        // Cookie-based auth: the httpOnly token cookie is sent automatically
        // (axios client has withCredentials: true), so no token is passed here.
        const response = await get(apiServer.category.all_list);
        const { data, status } = response;

        if (status === 200) {
          if (data.success && data.data) {
            // Format categories for dropdown
            const formattedCategories = data.data.map(category => ({
              label: `${category.name?.eng || ''} : ${category.name?.mm || ''}`,
              value: category.id
            }));
            setCategoryList(formattedCategories);
          } else if (Array.isArray(data)) {
            // Handle direct array response
            const formattedCategories = data.map(category => ({
              label: `${category.name?.eng || ''} : ${category.name?.mm || ''}`,
              value: category.id
            }));
            setCategoryList(formattedCategories);
          }
        }
      } catch (err) {
        console.error('Failed to fetch categories:', err);
      }
    };

    fetchCategories();
  }, []); // Empty dependency array - run only once

  // Separate useEffect for auto-selecting first category
  useEffect(() => {
    if (categoryList.length > 0 && chosenCategory === "") {
      onChangeSelect('chosenCategory', categoryList[0]);
    }
  }, [categoryList, chosenCategory, onChangeSelect]);

  return (
    <div className="create-product-form">
        <div className="create-product-form-left-side">
            <div className="create-product-form-row">
                <InputField
                    title='Name (in English)'
                    isRequired
                    id="Product Name English"
                    name='productEngName'
                    value={productEngName}
                    onChange={onChange}
                    main-width="100%"
                    width={'230px'}
                    layout="horizontal"
                    isFlag={"productEngName" in errorStates || productEngName?.length > 100}
                    errMsg={productEngName?.length > 100 ? "Must not exceed more than 100 words" :errorStates.productEngName}
                />
            </div>
            <div className="create-product-form-row">
                <InputField
                    title='Name (in Myanmar)'
                    isRequired
                    id="Product Name Myanmar"
                    name='productMyanName'
                    value={productMyanName}
                    onChange={onChange}
                    main-width="100%"
                    width={'230px'}
                    layout="horizontal"
                    isFlag={"productMyanName" in errorStates || productMyanName?.length > 100}
                    errMsg={productMyanName?.length > 100 ? "Must not exceed more than 100 words" : errorStates.productMyanName}
                />
            </div>
            <div className="create-product-form-row">
                <InputField
                    title="Product Code"
                    isRequired
                    id="Product Code"
                    name="productCode"
                    value={productCode}
                    onChange={onChange}
                    main-width="100%"
                    width={'230px'}
                    layout="horizontal"
                    isFlag={"productCode" in errorStates || productCode?.length > 250}
                    errMsg={productCode?.length > 250 ? "Must not exceed more than 250 words" : errorStates.productCode}
                />
            </div>
            <div className="create-product-form-row">
                <InputField
                    title="Category"
                    isRequired
                    id="Category"
                    fieldType={"search-select"}
                    main-width="100%"
                    isFlag={"chosenCategory" in errorStates}
                    errMsg={errorStates.chosenCategory}
                    layout="horizontal"
                    selectBoxClassName={"choose-product-select-box"}
                    selectValue={chosenCategory}
                    selectOptionList={categoryList}
                    searchableSelect
                    onChangeSelectBox= {(chosenValue) => {
                        onChangeSelect("chosenCategory", chosenValue)
                    }}
                />
            </div>
            <div className="create-product-form-row">
                <InputField
                    title="Price"
                    isRequired
                    id="Price"
                    main-width="100%"
                    layout="horizontal"
                    fieldType={"customize"}
                    isFlag={"currency" in errorStates || "price" in errorStates || price?.length > 50}
                    errMsg={price?.length > 50 ? "Must not exceed more than 50 words" :'This is mandatory field'}
                >
                <div className="create-product-choose-price-contaier">
                    <select value={currency} name='currency' style={{width: '80px'}} className="input-field-currency-selectbox"  onChange={onChange}>
                        {/* <option value={1}>$</option> */}
                        <option value={3}>MMK</option>
                        {/* <option value={2}>€</option> */}
                    </select>
                    <input
                        type="integer"
                        id="price"
                        name="price"
                        value={price}
                        onChange={onChange}
                        className="choose-price-input-box"
                    />
                </div>
                </InputField>
            </div>
        </div>
        <div className="create-product-form-right-side">
            <div className="create-product-form-row">
            <InputField
                title="Quantity"
                isRequired
                id="Quantity"
                main-width="100%"
                width='230px'
                layout={"horizontal"}
                type="integer"
                value={quantity}
                name='quantity'
                onChange={onChange}
                isFlag={"quantity" in errorStates}
                errMsg={errorStates.quantity}
                />
            </div>
            <div className="create-product-form-row">
                <InputField
                    title="Description( in English )"
                    isRequired
                    id="engDescription"
                    main-width="100%"
                    width='97%'
                    layout="vertical"
                    fieldType={"textarea"}
                    name='engDescription'
                    description={engDescription}
                    onChangeDescription={onChange}
                    isFlag={"engDescription" in errorStates}
                    errMsg={errorStates.engDescription}
                />
            </div>
            <div className="create-product-form-row">
                <InputField
                    title="Description ( in Myanmar) "
                    isRequired
                    id="myanDescription"
                    name='myanDescription'
                    main-width="100%"
                    width='97%'
                    layout={"vertical"}
                    fieldType="textarea"
                    description={myanDescription}
                    onChangeDescription={onChange}
                    isFlag={"myanDescription" in errorStates}
                    errMsg={errorStates.myanDescription}
                />

            </div>               
        </div>
      
    </div>
  );
};

export default GeneralInformation;
